import React from 'react';

export default function SuccessCheckmark({ message = 'Transaction Saved Successfully!', onClose }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
        textAlign: 'center',
        gap: '16px'
      }}
    >
      <div style={{ width: '80px', height: '80px', position: 'relative' }}>
        <svg
          viewBox="0 0 52 52"
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            display: 'block',
            boxShadow: '0 0 24px rgba(16, 185, 129, 0.4)'
          }}
        >
          <circle
            className="checkmark-circle"
            cx="26"
            cy="26"
            r="24"
            fill="rgba(16, 185, 129, 0.1)"
          />
          <path
            className="checkmark-check"
            fill="none"
            stroke="#10b981"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
          />
        </svg>
      </div>

      <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#f1f2f6', margin: 0 }}>
        {message}
      </h3>

      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="btn-primary touch-target"
          style={{
            marginTop: '12px',
            padding: '12px 28px',
            borderRadius: '12px',
            fontSize: '14px',
            width: 'auto'
          }}
        >
          Done
        </button>
      )}
    </div>
  );
}
